import { useState } from "react";
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { LogoutButton, LogoutConfirmDialog } from "@/components/auth/LogoutButtonWithConfirm";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function SuperAdminMobileHeader() {
  const { t } = useTranslation("common");
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleLogoutClick = () => {
    setUserMenuOpen(false);
    setTimeout(() => {
      setLogoutDialogOpen(true);
    }, 200);
  };

  return (
    <>
      {/* Background blanc permanent pour la status bar iOS */}
      <div className="safe-area-bg" />
      
      <header className="fixed-header-mobile bg-super-admin-header-bg border-b border-super-admin-header-border lg:hidden">
        <div className="flex items-center justify-between h-14 px-4">
          <SidebarTrigger className="text-super-admin-sidebar-text" />
          <h1 className="text-lg font-bold text-super-admin-sidebar-text">Super Admin</h1>
          
          <Popover open={userMenuOpen} onOpenChange={setUserMenuOpen}>
            <PopoverTrigger asChild>
              <Button
                variant="ghost"
                size="sm"
                className="relative h-8 w-8 p-0 hover:bg-super-admin-sidebar-hover"
                aria-label={t("userMenu", "Menu")}
              >
                <Avatar className="h-7 w-7">
                  <AvatarImage src="" alt="super admin" />
                  <AvatarFallback className="bg-super-admin-sidebar-active text-super-admin-sidebar-text text-xs">SA</AvatarFallback>
                </Avatar>
              </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-64 p-0 bg-background" sideOffset={8}>
              <div className="border-b px-4 py-3 bg-muted">
                <p className="font-semibold text-sm">Super Admin</p>
              </div>
              
              <div className="py-1">
                <Link 
                  to="/super-admin/settings" 
                  className="flex items-center w-full px-4 py-2 text-sm hover:bg-muted transition-colors cursor-pointer"
                  onClick={() => setUserMenuOpen(false)}
                >
                  <Settings className="h-4 w-4 mr-2" />
                  <span>{t("settings")}</span>
                </Link>
                
                <div className="h-px bg-border my-1" />
                
                <div className="px-4 py-2">
                  <LogoutButton onClick={handleLogoutClick} />
                </div>
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </header>

      {/* Dialog de confirmation rendu EN DEHORS du Popover */}
      <LogoutConfirmDialog 
        open={logoutDialogOpen} 
        onOpenChange={setLogoutDialogOpen} 
      />
    </>
  );
}
